(function () {
  "use strict";

  const dropdowns = document.querySelectorAll("[data-sort-dropdown]");

  dropdowns.forEach((select) => {
    select.addEventListener("change", () => {
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", select.value);
      url.searchParams.delete("page");
      window.location.href = url.toString();
    });
  });
})();
